import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Tabs} from "antd";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {
  StyledAutomationsGrid,
  StyledAutomationsPageContent,
  StyledAutomationsTabsContainer,
  StyledAutomationsTabDescription,
} from "./automations.style";
import {WorkflowsCardList, IntegrationsCardList} from "./components/automation-card";

const {TabPane} = Tabs;

type AutomationTab = "workflows" | "integrations";

function parseTabParam(value: string | null): AutomationTab | null {
  if (value === "workflows" || value === "integrations") {
    return value;
  }
  return null;
}

export function AutomationsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = parseTabParam(searchParams.get("tab"));
  const [activeTab, setActiveTab] = useState<AutomationTab>(tabFromUrl ?? "workflows");

  useEffect(() => {
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleTabChange = (key: string) => {
    const tab = key as AutomationTab;
    setActiveTab(tab);
    setSearchParams({tab}, {replace: true});
  };

  return (
    <DashboardWrapper pageTitle="Automations">
      <StyledPageHeader>Automations</StyledPageHeader>
      <StyledAutomationsPageContent>
        <StyledAutomationsTabsContainer>
          <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <TabPane tab="Workflows" key="workflows">
              <StyledAutomationsTabDescription>
                Set up automated actions that trigger based on your customers' activity
              </StyledAutomationsTabDescription>
              <StyledAutomationsGrid>
                <WorkflowsCardList />
              </StyledAutomationsGrid>
            </TabPane>
            <TabPane tab="Integrations" key="integrations">
              <StyledAutomationsTabDescription>
                Connect Coachli to the tools you already use
              </StyledAutomationsTabDescription>
              <StyledAutomationsGrid>
                <IntegrationsCardList />
              </StyledAutomationsGrid>
            </TabPane>
          </Tabs>
        </StyledAutomationsTabsContainer>
      </StyledAutomationsPageContent>
    </DashboardWrapper>
  );
}
